import { Component, Fragment, h, Prop } from '@stencil/core';
import { Unsubscribe } from '@stencil/redux';
import { RootState } from '../../../../redux/reducers';
import { store } from '../../../../redux/store';
import { ButtonAppearance, ButtonSize } from '../../rentware-button/types';
import GoBackIcon from '../../svg-elements/go-back-icon';
import { t } from '../../../../redux/utils';

@Component({
  tag: 'rentware-secure-details',
  shadow: false,
})
export class RentwareSecureDetails {
  @Prop({ mutable: true }) systemState;
  @Prop() onBackButtonClick: () => void;
  @Prop() secureTitle: string;
  @Prop() goBackText: string;

  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        systemState: state.system,
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get buttonAppearance(): ButtonAppearance {
    return {
      fullWidth: true,
      size: ButtonSize.XL,
    };
  }

  get customerTerms() {
    return this.systemState.footerLinks;
  }

  get secureText() {
    return this.systemState.company + ' ' + this.disclaimerText;
  }

  get disclaimerText() {
    return t('secure.disclaimer');
  }

  get secureByText() {
    return t('secure.secureBy');
  }

  get imprintText() {
    return t('secure.imprint');
  }

  get privacyText() {
    return t('secure.privacy');
  }

  render() {
    return (
      <div class="SecureDetailsContainer">
        <div class="SecureDetailsContainerInner">
          <div class="SecureHeaderContainer">
            <span class="SecureHeaderTitle">{this.secureTitle}</span>

            <div class="GlobalButtonSVG" onClick={this.onBackButtonClick} tabindex="0">
              <GoBackIcon onClick={this.onBackButtonClick} tabindex="0" />
            </div>
          </div>

          <rentware-spacer size="M" />

          <span class="SecureTitle">{this.secureByText} Rentware</span>

          <rentware-spacer size="S" />

          <div class="SecureDisclaimer" innerHTML={this.secureText} />

          <rentware-spacer size="M" />

          {!!this.customerTerms && (
            <Fragment>
              <div class="TermsContainer">
                <span>{this.systemState.shopTitle}:</span>

                {this.customerTerms.map(term => {
                  return (
                    <a href={term.url} target="_Blank">
                      {term.name}
                    </a>
                  );
                })}
              </div>

              <rentware-spacer size="S" />
            </Fragment>
          )}

          <div class="TermsContainer">
            Rentware:
            <a href="https://rentware.com" target="_Blank">
              Rentware.com
            </a>
            <a href="https://rentware.com/en/site-notice" target="_Blank">
              {this.imprintText}
            </a>
            <a href="https://rentware.com/en/privacy-policy" target="_Blank">
              {this.privacyText}
            </a>
          </div>

          <rentware-spacer size="L" />

          <rentware-button class="SecureButton" appearance={this.buttonAppearance} buttonText={this.goBackText} onClick={this.onBackButtonClick} />
        </div>
      </div>
    );
  }
}
